import { ModalCrearInputacion } from "../../../components/modals/CrearInputacion";
import { useMemo, useState } from "react";
import { createColumnHelper } from "@tanstack/react-table";
import { TypedTable } from "../../../components/TypedTable";
import { Loading, QueryError } from "../../../components/Loading/Loading";
import type { ArticuloFabricacion } from "../../../hooks/Api/Articulos";

interface TablaArticulosProps {
	readonly data: ArticuloFabricacion[] | null | undefined;
	readonly error: Error | null;
	readonly isPending: boolean;
}
export function TablaArticulos(props: TablaArticulosProps) {
	const [artCreandoInputacion, setArtCreandoInputacion] = useState<number | null>(null);
	const { data, error, isPending } = props;

	const columns = useMemo(() => {
		const columnHelper = createColumnHelper<ArticuloFabricacion>();
		const formatter = new Intl.NumberFormat("es-ES", { maximumFractionDigits: 2, minimumFractionDigits: 0 });
		const defaultNumberFormat = (value: number | null) => value != null ? formatter.format(value) : "-";

		const getAccionesArticulo = (articulo: ArticuloFabricacion) => {
			if ((articulo.tipoArticulo == 2 || articulo.tipoArticulo == 5) && articulo.rutaFabricacion != null) {
				return (
					<div className="clickable mostrarModalLanzarInputacion" data-id-articulo={articulo.idArticulo}>
						<i className="fa fa-plus" />
					</div>
				);
			} else {
				return <div style={{ width: "36px" }} />;	// placeholder to somewhat keep the column width consistent
			}
		};

		return [
			columnHelper.accessor("nombreFamilia", { header: "Familia", cell: info => info.getValue() ?? "-", meta: { className: "dt-center" } }),
			columnHelper.accessor("nombreArticulo", { id: "articulo", header: "Artículo", meta: { className: "dt-center" } }),

			// columnHelper.accessor("m382_xpeso", { header: "Peso", cell: info => defaultNumberFormat(info.getValue()), meta: { className: "dt-center" } }),
			columnHelper.accessor("max", { header: "Máximo", cell: info => defaultNumberFormat(info.getValue()), meta: { className: "dt-center" } }),
			columnHelper.accessor("min", { header: "Mínimo", cell: info => defaultNumberFormat(info.getValue()), meta: { className: "dt-center" } }),
			columnHelper.accessor("pendienteEntrada", { header: "Pdte. Entrada", cell: info => defaultNumberFormat(info.getValue()), meta: { className: "dt-center" } }),
			columnHelper.accessor("pendienteSalida", { header: "Pdte. Salida", cell: info => defaultNumberFormat(info.getValue()), meta: { className: "dt-center" } }),
			columnHelper.accessor("stock", { header: "Existencias", cell: info => defaultNumberFormat(info.getValue()), meta: { className: "dt-center" } }),
			columnHelper.accessor("entrarRecomendado", { header: "PEDIR", cell: info => defaultNumberFormat(info.getValue()), meta: { className: "dt-center" } }),
			// columnHelper.accessor("ped_lista", { header: "Pdte. Empaquetar", cell: info => defaultNumberFormat(info.getValue()), meta: { className: "dt-center" } }),

			columnHelper.display({
				id: "actions",
				header: "",
				meta: { className: "p-0 h-full" },
				cell: ({ row }) => getAccionesArticulo(row.original),
			}),

		];
	}, []);


	if (error) return <QueryError error={error} fallback="Error al cargar los artículos" />;
	if (isPending) return <Loading />;

	const onClickDT = (event: React.MouseEvent<HTMLDivElement>) => {
		const target = (event.target as HTMLElement | null)?.closest(".mostrarModalLanzarInputacion") as HTMLElement | null;
		if (!target) {
			return;
		}
		const idArticulo = target.dataset.idArticulo;
		if (idArticulo) {
			setArtCreandoInputacion(parseInt(idArticulo));
		}
	};
	return <>
		<div onClick={onClickDT}>
			<TypedTable
				className="dataTable display"
				data={data ?? []}
				columns={columns}

				pagination
				globalSearch
			/>
		</div>

		<ModalCrearInputacion
			show={artCreandoInputacion != null}
			close={() => setArtCreandoInputacion(null)}
			data={data ?? null}
			articulo={data?.find(art => art.idArticulo === artCreandoInputacion) ?? null}
		/>
	</>;
}
